/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./input-color.vue?vue&type=template&id=5b9ba9d0&scoped=true&"
import script from "./input-color.vue?vue&type=script&lang=js&"
export * from "./input-color.vue?vue&type=script&lang=js&"
import style0 from "./input-color.vue?vue&type=style&index=0&id=5b9ba9d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9ba9d0",
  null
  
)

export default component.exports